import GitiumSettingType from './types/setting'
import { composeAPI } from '@iota/core'
import { API } from '@iota/core/typings/core/src/composeAPI'
import GitiumRequest, { GitiumRequestObject } from './request'
import UserAddress from './address/index'

export interface GitiumAPI {
  iota: API
  request: GitiumRequestObject
}

class GitiumPOST {
  iota: API
  request: GitiumRequestObject
  constructor(setting: GitiumSettingType) {
    this.iota = composeAPI({
      provider: setting.unCenterUrl
    })
    this.request = GitiumRequest({
      centerUrl: setting.centerUrl,
      unCenterUrl: setting.unCenterUrl,
      timeout: setting.timeout
    })
  }
}

export default function StartGitium(setting: GitiumSettingType) {
  let post = new GitiumPOST({
    centerUrl: setting.centerUrl,
    unCenterUrl: setting.unCenterUrl,
    timeout: setting.timeout
  })

  let addressInstance = new UserAddress(post)
  return {
    GenerateAddress: addressInstance.genAddress,
    getAccountInfoByFirstAddress: addressInstance.getAccountInfoByFirstAddress,
    getAddressList: addressInstance.getAddressList
  }
}
